module.exports = __webpack_public_path__ + "static/media/about-us.9850f947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/about-us.jpg
// module id = 1235
// module chunks = 0